import { lock, clearBodyLocks } from 'tua-body-scroll-lock';
import '../scss/components/header-menu.scss';

export default {
    init() {
        //Stops menu from animating on load
        if (document.body.classList.contains('menu-no-animation')) {
            document.body.classList.remove('menu-no-animation');
        }
        //////////// Navigation
        const headerMenu = document.querySelector(
            '.header-menu'
        ) as HTMLElement;
        const hamburger = document.getElementById('hamburger');
        const menuItems = document.querySelector(
            '.header-menu-overlay-links'
        ) as HTMLElement;

        if (headerMenu && hamburger && menuItems) {
            if (window.matchMedia('screen and (max-width: 1023px)').matches) {
                const footerArea = document.querySelector(
                    '.footer-area'
                ) as HTMLElement;
                const footerHeight = footerArea ? footerArea.offsetHeight : 0;
                const headerHeight = 66;

                const menuItemsHeight =
                    window.innerHeight - footerHeight - headerHeight;

                menuItems.style.height = menuItemsHeight + 'px';
            }

            hamburger.addEventListener('click', () => {
                headerMenu.classList.toggle('open');
                hamburger.classList.toggle('close');

                if (headerMenu.classList.contains('open')) {
                    lock(menuItems);
                } else {
                    clearBodyLocks();
                }
            });

            const menuItemSub: NodeListOf<Element> =
                headerMenu.querySelectorAll('.menu-item-sub');

            if (menuItemSub.length) {
                menuItemSub.forEach((item) => {
                    const button: HTMLButtonElement | null =
                        item.querySelector('button');

                    if (button) {
                        button.addEventListener('click', () => {
                            const activeMenuItemSub = headerMenu.querySelector(
                                '.menu-item-sub.active'
                            );

                            item.classList.toggle('active');

                            if (activeMenuItemSub) {
                                activeMenuItemSub.classList.remove('active');
                            }
                        });
                    }
                });

                // Open first sub menu item
                menuItemSub[0].classList.add('active');
            }
        }
    }
};
